'use client';

import ReactPaginate from 'react-paginate';
import { useTheme } from '@emotion/react';
import { DEVICE_SCREENS_MAX_STRING } from '../lib/consts';

type IPaginationProps = {
  changePage: (selectedItem: { selected: number }) => void;
  currentPage?: number;
  count: number;
  onPrevPage: VoidFunction;
  onNextPage: VoidFunction;
};

export function Pagination({
  currentPage,
  count,
  changePage,
  onPrevPage,
  onNextPage,
}: IPaginationProps) {
  const theme = useTheme();
  return (
    <div
      css={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 0',
      }}
    >
      <div
        css={{
          fontFamily: 'Golos',
          display: 'flex',
          alignItems: 'center',
          'ul li': {
            display: 'inline',
            padding: '8px 16px',
            cursor: 'pointer',
            fontSize: 16,
            fontWeight: 500,
            color: theme.colors.text,
          },
          'ul li:first-child': {
            padding: 0,
          },
          'ul li:last-child': {
            padding: 0,
          },
          'ul li:not(.active-page):hover': {
            color: theme.colors.red,
          },
          '.active-page': {
            color: 'gray',
          },
          [DEVICE_SCREENS_MAX_STRING.md]: {
            'ul li': {
              padding: '8px 12px',
            },
          },
        }}
      >
        <button
          type='button'
          onClick={() => {
            onPrevPage();
            window.scrollTo(0, 0);
          }}
          css={{
            cursor: 'pointer',
            padding: '8px 16px',
            fontSize: 16,
            fontWeight: 500,
            ':hover': {
              color: theme.colors.red,
            },
          }}
        >
          «
        </button>
        <ReactPaginate
          breakLabel='...'
          nextLabel={null}
          previousLabel={null}
          forcePage={currentPage}
          marginPagesDisplayed={1}
          onPageChange={(event) => {
            changePage(event);
            window.scrollTo(0, 0);
          }}
          pageRangeDisplayed={3}
          activeClassName='active-page'
          pageCount={count}
          renderOnZeroPageCount={null}
        />
        <button
          type='button'
          onClick={() => {
            onNextPage();
            window.scrollTo(0, 0);
          }}
          css={{
            cursor: 'pointer',
            padding: '8px 16px',
            fontSize: 16,
            fontWeight: 500,
            ':hover': {
              color: theme.colors.red,
            },
          }}
        >
          »
        </button>
      </div>
    </div>
  );
}
